export default {
  name: 'VDebug',
  components: {},
  props: {
    debugResponseJSON: {
      type: Object,
      default: () => {}
    },
    debugLoading: {
      type: Boolean
    }
  },
  data() {
    return {
      copyable: {
        copyText: '复制',
        copiedText: '复制成功'
      }
    };
  },
  computed: {},
  mounted() {},
  methods: {},
  watch: {}
};